<template>
    <v-row>
        <v-col>
            <loader v-if="loading" />
            <sales-pivot v-else
                defaultSort="totalCount"
                :dataObject="stats"
                :fields="fields"
                :nestedFields="nestedFields"
                :equalCols="true"
                :valueFunctions="valueFunctions" />
        </v-col>
    </v-row>
</template>

<script>
import SalesPivot from '@/components/salesPivot.vue'

export default {
    components: {
        SalesPivot
    },
    data () {
        return {
            loading: true,
            firstRow: 'UserLastLock.Name',
            secondRow: 'Campaign.Name',
            rows: [
                {
                    text: 'Agentur',
                    value: 'UserLastLock.Name'
                },
                {
                    text: 'Kampagne',
                    value: 'Campaign.Name'
                }
            ],
            stats: null,
            fields: [
                {
                    header: '1. uge',
                    field: 'oneweekCount',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: '2. uge',
                    field: 'twoweeksCount',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: '3. uge+',
                    field: 'oldCount',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },

                {
                    header: 'Total',
                    field: 'totalCount',
                    cols: '2',
                    formatter: this.$options.filters.separator
                }
            ],
            valueFunctions: {
                'oneweekCount': v => v.oneweekCount,
                'twoweeksCount': v => v.twoweeksCount,
                'oldCount': v => v.oldCount,
                'totalCount': v => v.totalCount
            },
            nestedFields: ['oneweekCount', 'twoweeksCount', 'oldCount', 'totalCount']
        }
    },
    methods: {
        async getData () {
            this.loading = true
            const response = await this.$http().get('processing/privateRedials', {
                params: {
                    firstKey: this.firstRow,
                    secondKey: this.secondRow
                }
            })
            this.stats = response.data
            this.loading = false
        }
    },
    created () {
        this.getData()
    }
}
</script>